export const setUrls = (urls = []) => dispatch => {
    dispatch({
        type: 'SET_URLS',
        payload: urls,
    })
}